import { mapActions } from 'vuex';
const docUpload_mixins = {       
    methods: {
        ...mapActions({
            ACT_docUpload: 'docUpload_store/ACT_docUpload',
            ACT_docUploadResult: 'docUpload_store/ACT_docUploadResult'
        }),
        MIX_docUpload (payload) {
            this.ACT_docUpload (payload);
        },
        MIX_docUploadResult (payload){
            //console.log('MIX_docUploadResult = ' + JSON.stringify(payload, null, 2))
            this.ACT_docUploadResult (payload);
        },
    }
}
export default {
    install (Vue, options) {
        Vue.mixin(docUpload_mixins)
    }
};  
  